import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import Tooltip from '@zola/zola-ui/src/components/Tooltip/Tooltip';
import { fadeAnimation } from 'components/navV3/PostAuth/VerticalNav/VerticalNav.styles';
import { COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const LinkWrapper = styled.div<{ secondary: boolean }>`
  position: relative;
  padding: ${({ secondary }) => (secondary ? `${SPACING.XS} 0` : '2px 0')};
`;

const activePrimaryLinkStyles = css`
  background-color: #e7e7e7;
  border-radius: ${SPACING.XS};
  text-decoration: none !important;
`;

export const PrimaryLink = styled(LinkV2)<{ active: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px ${SPACING.SM};
  ${({ active }) => active && activePrimaryLinkStyles};
  :hover {
    ${activePrimaryLinkStyles}
  }
`;

export const SecondaryLink = styled(LinkV2)`
  display: flex;
  align-items: center;
  :hover {
    text-decoration: none !important;
  }
`;

export const LinkIcon = styled.span`
  display: flex;
  margin-right: ${SPACING.SM};
`;

export const LinkName = styled.span<{ open?: boolean; active: boolean }>`
  white-space: nowrap;
  ${FONT.textSizeCompact(FONT.SIZE.SMALLER)};
  font-weight: ${({ active }) => (active ? FONT.WEIGHT.SEMI_BOLD : FONT.WEIGHT.REGULAR)};
  opacity: 0;
  ${({ open }) => open && fadeAnimation(open)}
`;

export const StyledTooltip = styled(Tooltip)<{ show: boolean; top?: number }>`
  position: fixed;
  ${({ show, top = 0 }) =>
    show
      ? `
        top: ${top}px;
        left: 226px; // NAV_OPEN_WIDTH + SPACING.SM
      `
      : `
        top: auto;
        left: -10000px;
        width: 1px;
        height: 1px;
        overflow: hidden;
      `}
  ${({ show }) => show && fadeAnimation(show, '300ms')}
  .tooltip {
    display: flex !important;
    align-items: center;
    height: 72px;
    width: 286px;
    font-size: ${FONT.SIZE.SMALL} !important;
    ::before {
      border-left: 6px solid transparent !important;
      border-right: 6px solid transparent !important;
      border-top: 6px solid ${COLORS3.BLACK_100} !important;
      border-bottom: none;
      left: -292px !important;
      top: 34px;
      transform: rotate(90deg);
      visibility: initial;
      opacity: 1;
    }
  }
`;
